import {State} from "../../libs/enum/state.enum";
import {Priority} from "../../libs/enum/priority.enum";
import {SupportTicketHistoryDto} from "./support-ticket-history.dto";

export class SupportTicketDto {

  // Zammad's ticket id, digits only
  public readonly id!: string;
  // The number Zammad's mails quote
  public readonly number: string | undefined;
  public subject!: string;
  public description: string | undefined;
  public readonly state!: State;
  public priority!: Priority;
  public lastUpdate: Date | undefined;
  public readonly created!: Date;
  public readonly userName: string | undefined;
  public readonly history: SupportTicketHistoryDto[] = [];
  // write-only: where the request was written, for the support
  public page: string | undefined;
  public appVersion: string | undefined;

  constructor(init?: Partial<SupportTicketDto> | undefined) {
    Object.assign(this, init);
    if (init?.lastUpdate) {
      this.lastUpdate = new Date(init.lastUpdate);
    }
    if (init?.created) {
      this.created = new Date(init.created);
    }
    if (init?.history && init.history.length > 0) {
      this.history = init.history.map(i => new SupportTicketHistoryDto(i))
        .sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
    } else {
      this.history = [];
    }
  }

  isEditable(): boolean {
    return false;
  }

  public getLastHistory(): SupportTicketHistoryDto | undefined {
    return this.history.length > 0 ? this.history[this.history.length - 1] : undefined;
  }

  public isOpen(): boolean {
    return this.state === State.CREATED || this.state === State.PENDING;
  }
}
